// extracted by mini-css-extract-plugin
export default {"card":"Contact_card__yH8xX","button":"Contact_button__WJPFN","cardButtons":"Contact_cardButtons__N8FC5","phoneScreenMargin":"Contact_phoneScreenMargin__iGY46"};